import _ from "lodash";

export default class AppError extends Error {
  code: string;
  sourceError?: Error;
  contextParams?: any;

  constructor(
    code: string,
    message: string,
    sourceError?: Error,
    contextParams?: any
  ) {
    super(message);
    this.code = code;
    this.sourceError = sourceError;
    this.contextParams = contextParams ?? {};
  }

  getMessageWithContext() {
    let message: string = this.message;

    _.each(this.contextParams, (contextParam: string, key: string) => {
      message = message.replaceAll("${" + key + "}", contextParam);
    });

    return message;
  }
}
